import { createContext, useReducer, useEffect } from 'react';
import SessionWarningModal from '../components/SessionWarningModal';
import AccountPendingDeletionModal from '../components/AccountPendingDeletionModal';
import { BASE_URL } from '../Urls.js';

export const AuthContext = createContext();

export const authReducer = (state, action) => {
    switch (action.type){
        case 'LOGIN':
            return { user: action.payload, authReady: true };
        case 'LOGOUT':
            return { user: null, authReady: true };
        case 'UPDATE_USER':
            if (!state.user) return state;
            return { ...state, user: { ...state.user, ...action.payload } };
        case 'AUTH_READY':
            return { ...state, authReady: true };
        default:
            return state;
    }
}

export const AuthContextProvider = ( {children} ) => {
    const [state, dispatch] = useReducer(authReducer, {
        user: null,
        authReady: false
    })

    useEffect(() => {
        let user = null;
        try {
            const rawUser = localStorage.getItem('user');
            user = rawUser ? JSON.parse(rawUser) : null;
        } catch {
            // Recover from corrupted local storage to avoid crashing the entire app.
            localStorage.removeItem('user');
            dispatch({type: 'AUTH_READY'});
            return;
        }

        if (user){
            // Check if token is expired
            if (user.loginTime && user.tokenExpiresIn) {
                const now = Date.now();
                const expirationTime = user.loginTime + user.tokenExpiresIn;

                if (now >= expirationTime) {
                    // Token expired, clear storage and don't restore user
                    localStorage.removeItem('user');
                    dispatch({type: 'AUTH_READY'});
                    return;
                }
            }

            dispatch({type: 'LOGIN', payload: user});

            (async () => {
                try {
                    const res = await fetch(`${BASE_URL}/api/user/${encodeURIComponent(user.username)}/profile`, {
                        headers: { Authorization: `Bearer ${user.token}` },
                    });
                    const json = await res.json();
                    if (!res.ok || json.accountPendingDeletion === undefined) return;
                    const patch = {
                        accountPendingDeletion: Boolean(json.accountPendingDeletion),
                        accountScheduledPurgeAt: json.accountScheduledPurgeAt || null,
                        hide_explicit_covers: json?.user?.hide_explicit_covers !== false,
                        displayName: json?.user?.displayName || '',
                    };
                    const raw = JSON.parse(localStorage.getItem('user') || '{}');
                    localStorage.setItem('user', JSON.stringify({ ...raw, ...patch }));
                    dispatch({ type: 'UPDATE_USER', payload: patch });
                } catch {
                    /* offline / stale session */
                }
            })();
        } else {
            dispatch({type: 'AUTH_READY'});
        }
    }, [])
    
    return (
        <AuthContext.Provider value={{...state, dispatch}}>
            { children }
            <SessionWarningModal />
            <AccountPendingDeletionModal />
        </AuthContext.Provider>
    )
}